/**
 * Polityka Prywatności – PPHU Imperium
 * Zgodna z RODO (Rozporządzenie UE 2016/679)
 */
import { useEffect } from 'react';
import { Link } from 'wouter';

export default function PolitykaPrywatnosci() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const adminData = {
    name: 'Robert Gostomczyk P.P.H.U. "IMPERIUM"',
    address: 'ul. Kosynierów 21, 76-100 Sławno, Polska',
    nip: '8391082956',
    email: 'pphuimperium@gmail.com',
  };

  const sectionStyle: React.CSSProperties = {
    marginBottom: '2rem',
  };
  const h2Style: React.CSSProperties = {
    fontFamily: "'Manrope', sans-serif",
    fontWeight: 800,
    fontSize: '1.25rem',
    textTransform: 'uppercase',
    color: '#1A2744',
    letterSpacing: '-0.01em',
    marginBottom: '0.75rem',
    paddingBottom: '0.5rem',
    borderBottom: '2px solid #F5C400',
  };
  const pStyle: React.CSSProperties = {
    fontFamily: "'Manrope', sans-serif",
    fontSize: '0.95rem',
    color: '#374151',
    lineHeight: 1.8,
    marginBottom: '0.75rem',
  };
  const ulStyle: React.CSSProperties = {
    fontFamily: "'Manrope', sans-serif",
    fontSize: '0.95rem',
    color: '#374151',
    lineHeight: 1.8,
    paddingLeft: '1.5rem',
    marginBottom: '0.75rem',
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F8F6' }}>

      {/* Hero */}
      <section style={{
        backgroundColor: '#1A2744',
        padding: '4rem 0 3rem',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'linear-gradient(rgba(245,196,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(245,196,0,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
          pointerEvents: 'none',
        }} aria-hidden="true" />
        <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', backgroundColor: '#F5C400' }} aria-hidden="true" />
        <div className="container" style={{ position: 'relative' }}>
          <nav aria-label="Breadcrumb" style={{ marginBottom: '1rem' }}>
            <Link href="/" style={{ color: 'rgba(248,248,246,0.5)', fontSize: '0.85rem', textDecoration: 'none', fontFamily: "'Manrope', sans-serif" }}>
              Strona główna
            </Link>
            <span style={{ color: 'rgba(248,248,246,0.3)', margin: '0 0.5rem', fontSize: '0.85rem' }}>›</span>
            <span style={{ color: '#F5C400', fontSize: '0.85rem', fontFamily: "'Manrope', sans-serif" }}>Polityka prywatności</span>
          </nav>
          <h1 style={{
            fontFamily: "'Manrope', sans-serif",
            fontWeight: 800,
            fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
            textTransform: 'uppercase',
            color: '#F8F8F6',
            letterSpacing: '-0.02em',
            lineHeight: 1.05,
            marginBottom: '0.75rem',
          }}>
            Polityka prywatności
          </h1>
          <p style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: '0.9rem',
            color: 'rgba(248,248,246,0.55)',
          }}>
            Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </section>

      {/* Content */}
      <main>
        <section style={{ padding: '4rem 0 5rem' }}>
          <div className="container" style={{ maxWidth: '860px' }}>

            <section style={sectionStyle}>
              <h2 style={h2Style}>1. Administrator danych osobowych</h2>
              <p style={pStyle}>
                Administratorem Twoich danych osobowych jest:
              </p>
              <p style={{ ...pStyle, backgroundColor: '#fff', border: '1px solid #E5E7EB', borderLeft: '3px solid #F5C400', padding: '1rem 1.25rem', borderRadius: '2px' }}>
                <strong>{adminData.name}</strong><br />
                {adminData.address}<br />
                NIP: {adminData.nip}<br />
                E-mail: <a href={`mailto:${adminData.email}`} style={{ color: '#1A2744', fontWeight: 600 }}>{adminData.email}</a>
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>2. Zakres, cele i podstawy przetwarzania</h2>
              <p style={pStyle}>Niniejsza polityka dotyczy osób odwiedzających stronę, kontaktujących się z Administratorem oraz korzystających z formularza kontaktowego. Strona nie umożliwia zakładania kont użytkownika, nie prowadzi newslettera ani nie wykorzystuje danych odwiedzających do zautomatyzowanego profilowania marketingowego.</p>
              <ul style={ulStyle}>
                <li><strong>Formularz kontaktowy i zapytania ofertowe</strong> – przetwarzamy imię i nazwisko, numer telefonu, wybraną kategorię zapytania oraz treść wiadomości. Dane służą odpowiedzi na pytanie, przygotowaniu oferty i podjęciu działań przed ewentualnym zawarciem umowy. Podstawą jest art. 6 ust. 1 lit. b RODO, a w przypadku zwykłych zapytań także art. 6 ust. 1 lit. f RODO, tj. prawnie uzasadniony interes Administratora polegający na obsłudze korespondencji.</li>
                <li><strong>Bezpieczeństwo i działanie strony</strong> – przetwarzane mogą być podstawowe dane techniczne, takie jak adres IP, informacje o przeglądarce, czas połączenia i informacje potrzebne do wykrywania nadużyć. Podstawą jest art. 6 ust. 1 lit. f RODO.</li>
                <li><strong>Statystyki odwiedzin</strong> – dane o sposobie korzystania ze strony są wykorzystywane wyłącznie po wyrażeniu zgody na analityczne pliki cookies. Podstawą jest art. 6 ust. 1 lit. a RODO.</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>3. Okres przechowywania danych</h2>
              <p style={pStyle}>Dane z formularza kontaktowego przechowujemy przez czas potrzebny do udzielenia odpowiedzi, obsługi zapytania i prowadzenia ewentualnej współpracy, a następnie przez okres niezbędny do ustalenia, dochodzenia lub obrony roszczeń, nie dłużej niż 3 lata od ostatniego kontaktu, chyba że przepisy wymagają dłuższego okresu. Dane analityczne są przechowywane zgodnie z ustawieniami narzędzia analitycznego albo do czasu wycofania zgody.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>4. Odbiorcy danych</h2>
              <p style={pStyle}>Dane mogą być dostępne wyłącznie dla osób upoważnionych przez Administratora oraz podmiotów wspierających działanie strony w zakresie niezbędnym do realizacji wskazanych celów, w szczególności dostawców hostingu, infrastruktury serwerowej, bazy danych, przechowywania plików, wsparcia technicznego i narzędzi analitycznych.</p>
              <p style={pStyle}>Administrator nie sprzedaje danych osobowych i nie udostępnia ich podmiotom trzecim do ich własnych celów marketingowych.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>5. Przekazywanie danych poza EOG</h2>
              <p style={pStyle}>Co do zasady Administrator korzysta z usług dostawców zapewniających odpowiednie środki ochrony danych. Jeżeli w związku z użyciem usług infrastruktury, analityki lub osadzonej mapy Google Maps dojdzie do przekazania danych poza Europejski Obszar Gospodarczy, odbywa się ono wyłącznie na zasadach przewidzianych w rozdziale V RODO, w tym z zastosowaniem odpowiednich zabezpieczeń dostawcy.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>6. Twoje prawa</h2>
              <p style={pStyle}>Na zasadach określonych w RODO przysługuje Ci prawo dostępu do danych, sprostowania danych, usunięcia danych, ograniczenia przetwarzania, przenoszenia danych, sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie oraz cofnięcia zgody w dowolnym momencie. Cofnięcie zgody nie wpływa na zgodność z prawem przetwarzania przed jej wycofaniem.</p>
              <p style={pStyle}>Aby skorzystać z praw, skontaktuj się z Administratorem pod adresem <a href={`mailto:${adminData.email}`} style={{ color: '#1A2744', fontWeight: 600 }}>{adminData.email}</a>. Masz również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, ul. Stanisława Moniuszki 1A, 00-014 Warszawa, <a href="https://uodo.gov.pl" target="_blank" rel="noopener noreferrer" style={{ color: '#1A2744', fontWeight: 600 }}>uodo.gov.pl</a>.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>7. Pliki cookies i Google Maps</h2>
              <p style={pStyle}>Strona używa niezbędnych plików cookies i podobnych technologii koniecznych dla podstawowego działania strony oraz zapamiętania decyzji dotyczącej cookies. Nie wymagają one odrębnej zgody.</p>
              <p style={pStyle}>Analityczne pliki cookies są uruchamiane wyłącznie po wyrażeniu zgody w banerze cookies. Zgodę możesz wycofać przez usunięcie danych strony w ustawieniach przeglądarki i ponowne wybranie decyzji w banerze.</p>
              <p style={pStyle}>Na stronie może być osadzona mapa Google Maps. Korzystanie z niej może wiązać się z przetwarzaniem danych technicznych przez Google na zasadach określonych w polityce prywatności tego dostawcy.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>8. Bezpieczeństwo danych</h2>
              <p style={pStyle}>Administrator stosuje odpowiednie środki techniczne i organizacyjne, aby chronić dane przed nieuprawnionym dostępem, utratą, zmianą lub zniszczeniem. Komunikacja ze stroną odbywa się z użyciem szyfrowanego połączenia HTTPS.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>9. Zmiany polityki i kontakt</h2>
              <p style={pStyle}>Polityka może być aktualizowana, gdy zmienią się funkcje strony, sposób przetwarzania danych albo przepisy prawa. Aktualna wersja jest zawsze publikowana na tej podstronie wraz z datą aktualizacji.</p>
              <p style={{ ...pStyle, backgroundColor: '#fff', border: '1px solid #E5E7EB', borderLeft: '3px solid #F5C400', padding: '1rem 1.25rem', borderRadius: '2px' }}>
                {adminData.name}<br />
                {adminData.address}<br />
                E-mail: <a href={`mailto:${adminData.email}`} style={{ color: '#1A2744', fontWeight: 600 }}>{adminData.email}</a>
              </p>
            </section>

            <div style={{ marginTop: '3rem', paddingTop: '1.5rem', borderTop: '1px solid #E5E7EB' }}>
              <Link href="/" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontFamily: "'Manrope', sans-serif",
                fontWeight: 700,
                fontSize: '0.85rem',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: '#1A2744',
                textDecoration: 'none',
              }}>
                ← Powrót na stronę główną
              </Link>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
}
